export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  // Aceleres: midia aberta a partir do painel de contato. O visualizador nao
  // pode viver dentro do painel -- fechar o painel desmonta a arvore inteira e
  // levaria a galeria junto --, entao quem escuta e a ConversationBox.
  OPEN_CONTACT_MEDIA_VIEWER: 'OPEN_CONTACT_MEDIA_VIEWER',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  ADD_MESSAGE_TO_NOTE: 'ADD_MESSAGE_TO_NOTE',
  EMOJI_PICKER_OPENED: 'EMOJI_PICKER_OPENED',
  // Aceleres 2026-08-18: o "+" da barra de reacoes rapidas, no telemovel, abre
  // a MESMA folha de emojis do compositor (a da carita, em baixo a esquerda) —
  // nao uma copia parecida. Estes dois eventos sao a conversa entre as duas
  // pontas: a mensagem pede a folha, a folha devolve o emoji escolhido.
  OPEN_REACTION_EMOJI_SHEET: 'OPEN_REACTION_EMOJI_SHEET',
  REACTION_EMOJI_SELECTED: 'REACTION_EMOJI_SELECTED',
  // Aceleres: o menu do Jarvis no compositor (botao de baixo). O item
  // "Pergunte ao Jarvis" da mensagem nao usa mais este evento: dispara
  // `reply_suggestion` no compositor.
  OPEN_COMPOSER_JARVIS_MENU: 'OPEN_COMPOSER_JARVIS_MENU',
  MESSAGE_INTERACTION_OPENED: 'MESSAGE_INTERACTION_OPENED',
  OPEN_MESSAGE_INFO: 'OPEN_MESSAGE_INFO',
  ACELERES_EQUIPE_ONLINE_REFRESH: 'ACELERES_EQUIPE_ONLINE_REFRESH',
  ACELERES_CONVERSATION_STARTED: 'ACELERES_CONVERSATION_STARTED',
  ACELERES_START_CONVERSATION_REQUESTED:
    'ACELERES_START_CONVERSATION_REQUESTED',
  ACELERES_CARTEIRIZACAO_REQUEST_UPDATED:
    'ACELERES_CARTEIRIZACAO_REQUEST_UPDATED',
  ACELERES_ATENDIMENTO_REQUEST_UPDATED: 'ACELERES_ATENDIMENTO_REQUEST_UPDATED',
  ACELERES_WAME_POOL_UPDATED: 'ACELERES_WAME_POOL_UPDATED',
  // Aceleres: chegou/mudou algo numa inbox de e-mail (aba E-mails da Caixa de
  // Entrada). O actionCable so avisa; quem recarrega e o useEmailInbox.
  ACELERES_EMAIL_INBOX_UPDATED: 'ACELERES_EMAIL_INBOX_UPDATED',
  INBOX_NOTIFICATION_UPDATED: 'INBOX_NOTIFICATION_UPDATED',
  ACELERES_REMINDERS_UPDATED: 'ACELERES_REMINDERS_UPDATED',
  ACELERES_CONVERSATION_PREVIEW_RECONCILED:
    'ACELERES_CONVERSATION_PREVIEW_RECONCILED',
  // Aceleres: "falar com este telefone". Quem escuta e a ChatList, que ja
  // hospeda o fluxo unico de iniciar conversa (selecao de instancia, aviso de
  // lead de outro vendedor, criacao e navegacao). O cartao de contato so pede
  // — repetir a acao numa bolha sairia de sincronia na primeira mudanca.
  ACELERES_OPEN_CHAT_WITH_PHONE: 'ACELERES_OPEN_CHAT_WITH_PHONE',
  // Aceleres: "mover para meus" pedido pelo menu do cabecalho da conversa.
  // O fluxo completo (delta de contador, troca para a aba Meus, refresh sem
  // cache) mora na ChatList, que nao e ancestral do cabecalho — o menu so
  // pede. Ver ChatList#onAssignMine.
  ACELERES_MOVE_TO_MINE_REQUESTED: 'ACELERES_MOVE_TO_MINE_REQUESTED',
};
